<script>

export default {
    name: 'Parte3',
    data(){
        return{
            fabricacao: false,
            recuperacao: false,
            obras: false,
            atividade: false
        }
    },
    methods:{
        abrir(valor){
            if(valor == 1){
                this.fabricacao = !this.fabricacao 
            }
            if(valor == 2){
                this.recuperacao = !this.recuperacao 
            }
            if(valor == 3){
                this.obras = !this.obras 
            }
            if(valor == 4){
                this.atividade = !this.atividade 
            }
                       
        }
    }
}

</script>

<template>
    <div class="main">

        <div class="bloco1">
            <div class="bloco2">
                <p class="titulo">SERVIÇOS ESPECIALIZADOS</p>
            </div>
            <div class="bloco3">
                <div class="bloco4">
                    <div class="bloco5">
                        <img @click="abrir(1)" :class="{ 'imagem_ativada': fabricacao }" class="imagem" src="../assets/imagens/fabricar.png" alt="">
                        <div class="bloco6" >
                            <p class="subtitulo">SERVIÇOS ESPECIALIZADOS FABRICAÇÃO</p>
                            <p class="text" v-show="fabricacao">CALDEIRARIA: Fabricação de Estruturas Metálicas; Miscelâneas Metálicas;
                                Moegas, Tanques,
                                Calhas, Vasos de pressão, Transportadores, Chutes de Descargas, Canal de Corrida, Anel
                                de
                                Ponte Rolante, etc, Fabricação de Tubulações e Spools em Geral, Recuperação de Brocas,
                                Cesto de Sucata, Distribuidor de Aço, Tampas de Panela de CDQ, Jaquetas, Caçambas,
                                Panela
                                de Aço, Canaletas de Sucata, Silos, Potes, Snokel do RH, Dentre Outros...</p>
                        </div>
                    </div>
                    <div class="bloco5">
                        <img @click="abrir(2)" :class="{ 'imagem_ativada': recuperacao }" class="imagem" src="../assets/imagens/recuperacao.png" alt="">
                        <div class="bloco6">
                            <p class="subtitulo">USINAGEM FABRICAÇÃO E RECUPERAÇÃO</p>
                            <p class="text" v-show="recuperacao">Fabricação de peças seriadas em torno CNC e centros de usinagem.
                                Fabricação de engrenagens, coroas, rodas dentadas, pinhões, cremalheiras de diversos
                                módulos.
                                Serviços em eletro-erosão.
                                Alto desempenho em fabricação de grandes lotes e peças com alto nível de precisão.</p>
                        </div>
                    </div>
                </div>
                <div class="bloco4">
                    <div class="bloco5">
                        <img @click="abrir(3)" :class="{ 'imagem_ativada': obras }" class="imagem" src="../assets/imagens/obras.png" alt="">
                        <div class="bloco6">
                            <p class="subtitulo">OBRAS DE MANUTENÇÃO INDUSTRIAL</p>
                            <p class="text" v-show="obras">PRINCIPAIS SERVIÇOS REALIZADOS</p>
                            <p class="text" v-show="obras">Manutenção Industrial em Regime de Parada de Fábrica no Setor de Siderurgia,
                                Petroquímica
                                e Mineração, Manutenção em sistemas hidráulicos/ Pneumáticos, Montagens de Tubulações
                                em Geral, Estruturas Metálicas, Manutenção de Caldeiras, Vasos de Pressão, Tanques e
                                Trocadores
                                de Calor, Equipamentos Estáticos e Rotativos;</p>
                        </div>
                    </div>
                    <div class="bloco5">
                        <img @click="abrir(4)" :class="{ 'imagem_ativada': atividade }" class="imagem" src="../assets/imagens/atividades.png" alt="">
                        <div class="bloco6">
                            <p class="subtitulo">NOSSAS ATIVIDADES</p>
                            <p class="text" v-show="atividade">PAPEL E CELULOSE, MINERAÇÃO, SIDERÚRGIA, ENERGIA, ALIMENTÍCIO, PORTUÁRIO,
                                OFFSHORE, ONSHORE, PETROLEO E GÁS.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@media (max-width: 900px) {
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100vw;
    background:
        linear-gradient(#ffffffd7, #ffffffd7),
        /* Gradiente escuro semi-transparente */
        url('../assets/imagens/logo-simbolo.png');
    /* Imagem de fundo */
    background-size: 25cm;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat: no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    margin:2rem 0rem;
}

.bloco1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
}

.bloco2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 5%;
}

.bloco3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.bloco4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1rem;
}

.bloco5 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content:baseline;
    text-align: center;
    gap: 1rem;
    background-color: #ffffff96;
    padding: 2%;
    border-radius: 10px;
    height: 150px;
}

.bloco6 {
    display: flex;
    flex-direction: column;
    text-align: justify;
    align-items: center;
    justify-content:center;
    gap: 0.5rem;
    
}

.imagem {
    width: 20%;
    padding: 1.5rem;
    border: 2px solid #444;
    border-radius: 10px;
    background-color: #fff;
    cursor: pointer;
}
.imagem:hover{
    background-color: #4444442c;
}
.imagem_ativada{
    background-color: #4444442c;
}
.subtitulo {
    font-size: 0.8rem;
    color: #444;
    font-weight: 600;
}

.text {
    font-size: 0.6rem;    
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    color: #fff;
    background-color: #444;
    padding: 1rem;
    border-radius: 5px;
}
}
@media (min-width: 901px) {
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    max-width: 100vw;
    background:
        linear-gradient(#ffffffd7, #ffffffd7),
        /* Gradiente escuro semi-transparente */
        url('../assets/imagens/logo-simbolo.png');
    /* Imagem de fundo */
    background-size: 25cm;
    /* Ajusta a imagem para cobrir completamente o elemento */
    background-repeat: no-repeat;
    /* Evita que a imagem se repita */
    background-position: center;
    /* Centraliza a imagem no elemento */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
}

.bloco1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
}

.bloco2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 5%;
}

.bloco3 {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.bloco4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 2rem;
}

.bloco5 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content:baseline;
    text-align: center;
    gap: 1rem;
    background-color: #ffffff96;
    padding: 2%;
    border-radius: 10px;
    height: 150px;
}

.bloco6 {
    display: flex;
    flex-direction: column;
    text-align: justify;
    align-items: center;
    justify-content:center;
    gap: 0.5rem;
    
}

.imagem {
    width: 20%;
    padding: 1.5rem;
    border: 2px solid #444;
    border-radius: 10px;
    background-color: #fff;
    cursor: pointer;
}
.imagem:hover{
    background-color: #4444442c;
}
.imagem_ativada{
    background-color: #4444442c;
}
.subtitulo {
    font-size: 0.9rem;
    color: #444;
    font-weight: 600;
}

.text {
    font-size: 0.8rem;    
}

.titulo {
    font-size: 2rem;
    font-weight: bold;
    color: #fff;
    background-color: #444;
    padding: 1rem;
    border-radius: 5px;
}
}
</style>